module.exports = __webpack_public_path__ + "static/media/icon-y-adult-female.f6cc45ef.svg";